<div class="bg-slate-5" style="position: relative" *ngIf="user">
    <div class="container-fluid user-account-container user-table-main">
        <app-courier-overview [user]="user"></app-courier-overview>
    </div>
</div>
